import { useEffect, useState } from "react";
import useMediaQuery from "@/hooks/useMediaQuery";

export default function useNavbar() {
  const isMobile = useMediaQuery("(max-width: 1227px)");
  const [openState, setOpenState] = useState(false);
  const [activeSubDrawerState, setActiveSubDrawerState] = useState<string | null>(null);

  // Derived rather than synced via effect: the drawer is only ever "open" on mobile
  const open = isMobile && openState;
  const activeSubDrawer = isMobile ? activeSubDrawerState : null;

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  const toggleDrawer = () => {
    setOpenState((prev) => {
      const next = !prev;
      if (!next) {
        setActiveSubDrawerState(null);
      }
      return next;
    });
  };

  const closeDrawer = () => {
    setActiveSubDrawerState(null);
    setOpenState(false);
  };

  const openSubDrawer = (id: string) => setActiveSubDrawerState(id);
  const closeSubDrawer = () => setActiveSubDrawerState(null);

  return {
    isMobile,
    open,
    activeSubDrawer,
    toggleDrawer,
    closeDrawer,
    openSubDrawer,
    closeSubDrawer,
    setActiveSubDrawer: setActiveSubDrawerState,
  } as const;
}
